var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 10,
    viewBox: "0 0 54 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.00002C0 4.86741 0.0526784 4.74024 0.146447 4.64647C0.240215 4.5527 0.367392 4.50002 0.5 4.50002H52.293L49.146 1.35402C49.0521 1.26013 48.9994 1.1328 48.9994 1.00002C48.9994 0.867245 49.0521 0.739908 49.146 0.646021C49.2399 0.552134 49.3672 0.49939 49.5 0.49939C49.6328 0.49939 49.7601 0.552134 49.854 0.646021L53.854 4.64602C53.9006 4.69247 53.9375 4.74764 53.9627 4.80839C53.9879 4.86913 54.0009 4.93425 54.0009 5.00002C54.0009 5.06579 53.9879 5.13091 53.9627 5.19165C53.9375 5.2524 53.9006 5.30758 53.854 5.35402L49.854 9.35402C49.7601 9.44791 49.6328 9.50065 49.5 9.50065C49.3672 9.50065 49.2399 9.44791 49.146 9.35402C49.0521 9.26013 48.9994 9.1328 48.9994 9.00002C48.9994 8.86725 49.0521 8.73991 49.146 8.64602L52.293 5.50002H0.5C0.367392 5.50002 0.240215 5.44734 0.146447 5.35357C0.0526784 5.25981 0 5.13263 0 5.00002Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.33f5c3345da2752ea22dd67aecd37b88.svg";
export { ForwardRef as ReactComponent };